import DocumentiSocioView from "./DocumentiSocioView";
import {useContext, useEffect, useState} from "react";
import {LoaderContext} from "../../context/LoaderContext";
import {downloadDoc} from "../../utility/common";
import {getDocumentiSocioApi, getDocumentoSocioByIdApi} from "../../services/UtentiServices";

export default function DocumentiSocioController() {

    const [documentiSocio, setDocumentiSocio] = useState([]);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    async function getDocumentiSocio() {
        startChiamata();
        const response = await getDocumentiSocioApi();
        setDocumentiSocio(response.data.data);
        endChiamata();
    }

    useEffect(() => {
        getDocumentiSocio();
    }, []);

    const downloadDocumento = async (doc) => {
        startChiamata();
        const response = await getDocumentoSocioByIdApi(doc.id_documento_soci);
        if (response.data.result === -1) {
            setModalMsg(response.data.description);
            setShow(true);
        } else {
            let resp = response.data.data;
            if (resp) {
                downloadDoc(resp)
            }
        }
        endChiamata();
    }

    return (
        <DocumentiSocioView
            documenti={documentiSocio}
            downloadDocumento={downloadDocumento}
            showMsg={show}
            setShowMsg={setShow}
            modalMsg={modalMsg}
        />
    );

}